module.exports = __webpack_public_path__ + "img/rank_1.b9957bf.png";